import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import "./attendanceList.css";
import { sidebarNavItems, ROUTES } from "../../../constant";
import SideBar from "../../commanComponents/sidebar/sidebar";
import { getCurrentDateInput } from '../../../utils/utils';
import { getClassListService, getSectionListService, getSessionListService, getAdminAttendanceListService, getAdminAttendanceSummaryListService } from "../../../modules/services";
import TopNavigation from "../../commanComponents/topNavigation/topNavigation";
import { clearData } from '../../../utils/localStorage';
import AdvancedTable from "../../commanComponents/advancedTable/advancedTable";
import PopoverFilter from '../../commanComponents/popoverFilter/popoverFilter';
import IconButton from "../../commanComponents/iconbutton/iconButton";


const AttendanceList = () => { 
    const [dataMeta, setDataMeta] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [dataSummaryMeta, setDataSummaryMeta] = useState([]);
    const [dataSummaryList, setDataSummaryList] = useState([]);
    const [isAttendanceList, setIsAttendanceList] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [summaryPageNo, setSummaryPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [sessionData, setSessionData] = useState([]);
    const [sectionData, setSectionData] = useState([]);
    const [classData, setClassData] = useState([]);
    const navigate = useNavigate();

    const FilterSchema = z.object({
        //session_filter
        session_filter: z.string(),
        //class_filter
        class_filter: z.string(),
        //section_filter
        section_filter: z.string(),
        //attend_date
        attend_date: z.date()
    });
    const { control: filterControl, register: filterRegister, getValues: filterGetValues, setValue: filterSetValue } = useForm({
        resolver: zodResolver(FilterSchema)
    });

    const renderDropdownListData = (listData, label, value, id) => {
        return(listData.map(data => ({label: data[label], value: data[value], id: data[id]})))
    }

    const getAttendanceData = (fromFilter, _pageNo) => { 
        
        const sessionFilterData = filterGetValues("session_filter");
        const classFilterData = filterGetValues("class_filter");
        const sectionFilterData = filterGetValues("section_filter");
        const attendDateFilterData = filterGetValues("attend_date");

        setIsLoading(true);
        (async () => {
            const responseData = await getAdminAttendanceListService({
                page: _pageNo,
                pagination: true,
                enrolled_student__session: typeof sessionFilterData === "undefined" ? "" : sessionFilterData,
                enrolled_student__session__school: "",
                enrolled_student__student__user_class: typeof classFilterData === "undefined" ? "" : classFilterData,
                enrolled_student__student__section: typeof sectionFilterData === "undefined" ? "" : sectionFilterData,
                attend_date: attendDateFilterData
            });
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                if (fromFilter) {
                    setDataList(responseData.data[0].results);
                }
                else {
                    setDataList([...dataList, ...responseData.data[0].results]);
                }
                setDataMeta(responseData.data[0].links);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    const getAttendanceSummaryData = (fromFilter, _pageNo) => { 
        const sessionFilterData = filterGetValues("session_filter");

        setIsLoading(true);
        (async () => {
            const responseData = await getAdminAttendanceSummaryListService({
                page: _pageNo,
                pagination: true,
                session: sessionFilterData
            });
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                if (fromFilter) {
                    setDataSummaryList(responseData.data[0].results);
                }
                else {
                    setDataSummaryList([...dataSummaryList, ...responseData.data[0].results]);
                }
                setDataSummaryMeta(responseData.data[0].links);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    const getSectionData = () => { 
        setIsLoading(true);
        (async () => {
            const responseData = await getSectionListService({pagination: false});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                let sectionList = renderDropdownListData(responseData.data, "name", "id", "id");
                sectionList = [{ label: "Select", value: "", id: undefined }, ...sectionList];

                setSectionData(sectionList);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    const getClassData = () => { 
        setIsLoading(true);
        (async () => {
            const responseData = await getClassListService({pagination: false});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                let classList = renderDropdownListData(responseData.data, "name", "id", "id");
                classList = [{ label: "Select", value: "", id: undefined }, ...classList];

                setClassData(classList);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    const getSessionData = () => {
        setIsLoading(true);
        (async () => {
            const responseData = await getSessionListService({pagination: false});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                const sessionList = renderDropdownListData(responseData.data, "session_name", "id", "id");

                setSessionData(sessionList);
                filterSetValue("session_filter", sessionList[0]?.value);
                getAttendanceSummaryData(false, 1);
                getAttendanceData(false, 1);

                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    useEffect(() => {
        const currentDate = getCurrentDateInput();
        getSessionData(currentDate)
        filterSetValue("attend_date", "");
        getClassData();
        getSectionData();
    }, []);

    const onChangeAttendanceSummaryToggle = (isFromAttendance) => {
        setIsAttendanceList(isFromAttendance);
    }

    const handleSectionFilterChange = () => { 
        const _pageNo = 1;
        setPageNo(_pageNo);
        getAttendanceData(true, _pageNo);
    }

    const handleClassFilterChange = () => { 
        const _pageNo = 1;
        setPageNo(_pageNo);
        getAttendanceData(true, _pageNo);
    }

    const handleDateFilterChange = (event) => {
        const _pageNo = 1;
        setPageNo(_pageNo);
        filterSetValue("attend_date", event.target.value);
        getAttendanceData(true, _pageNo);
    }

    const handleLoadMore = () => { 
        if (dataMeta.next) {
            setIsLoading(true);
            const _pageNo = dataMeta.current + 1;
            setPageNo(_pageNo);
            getAttendanceData(false, _pageNo);
        }
    }

    const onClickAttendance = () => {

    }

    const tableColumnsList = [
        {
            accessor: data => data.student_first_name + " " + data.student_last_name,
            Header: 'Full Name',
            minWidth: 170,
            onClick: true,
        },
        {
            accessor: data => data.is_absent ? "Absent" : "Present",
            Header: 'Status',
            maxWidth: 130,
            minWidth: 120,
        },
        {
            accessor: 'attend_date',
            Header: 'Date',
            maxWidth: 130,
            minWidth: 120,
            isFilter: true,
            popoverFilter: PopoverFilter,
            inputKey: "attend_date",
            placeholder: "Attend Date",
            filterType: "date",
            onChange: handleDateFilterChange,
            control: filterRegister,
        },
        {
            accessor: 'class_name',
            Header: 'Class',
            maxWidth: 130,
            minWidth: 120,
            isFilter: true,
            popoverFilter: PopoverFilter,
            filterDataList: classData,
            control: filterControl,
            inputKey: "class_filter",
            placeholder: "Class",
            onChange: handleClassFilterChange,
        },
        {
            accessor: 'section_name',
            Header: 'Section',
            maxWidth: 130,
            minWidth: 130,
            isFilter: true,
            popoverFilter: PopoverFilter,
            filterDataList: sectionData,
            control: filterControl,
            inputKey: "section_filter",
            placeholder: "Section",
            onChange: handleSectionFilterChange,
        },
        {
            accessor: data => data.mentor_first_name + " " + data.mentor_last_name,
            Header: 'Mentor Name',
            minWidth: 190,
        },
    ];

    const tableColumnsSummary = [
        {
            accessor: 'attend_date',
            Header: 'Date',
            maxWidth: 130,
            minWidth: 120,
            onClick: true,
        },
        {
            accessor: 'class_name',
            Header: 'Class',
            maxWidth: 130,
            minWidth: 120,
        },
        {
            accessor: 'section_name',
            Header: 'Section',
            maxWidth: 130,
            minWidth: 130,
        },
        {
            accessor: "total_student",
            Header: 'Total Students',
            minWidth: 170,
        },
        {
            accessor: "present_student",
            Header: 'Present Students',
            minWidth: 170,
        },
        {
            accessor: "absent_student",
            Header: 'Absent Students',
            minWidth: 170,
        },
        {
            accessor: data => data.mentor_first_name + " " + data.mentor_last_name,
            Header: 'Mentor Name',
            minWidth: 190,
        },
    ];
    
    return (
        <div className='attendance-list-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.adminAttendace} />
            <div className='attendance-list-side-container'>
                <TopNavigation activeItem={sidebarNavItems.adminAttendace} />
                
                <div className='row attendance-list-filter-container attendance-list-filter-screen'>
                    <div className='col attendance-list-filter-inner-div'>
                        <IconButton
                            iconName="bi-grid-3x3-gap-fill"
                            onChange={() => onChangeAttendanceSummaryToggle(false)}
                            customStyle={
                                isAttendanceList
                                    ?
                                    { backgroundColor: "white", color: "#293659", borderRadius: "5px", width: "30px", height: "30px", border: "solid 1px #d6d6d6" }
                                    :
                                    { backgroundColor: "#293659", color: "white", borderRadius: "5px", width: "30px", height: "30px" }
                            }
                        />
                        <IconButton
                            iconName="bi-list"
                            onChange={() => onChangeAttendanceSummaryToggle(true)}
                            customStyle={
                                isAttendanceList
                                    ?
                                    { backgroundColor: "#293659", color: "white", borderRadius: "5px", width: "30px", height: "30px", marginLeft: "10px" }
                                    :
                                    { backgroundColor: "white", color: "#293659", borderRadius: "5px", width: "30px", height: "30px", marginLeft: "10px", border: "solid 1px #d6d6d6" }
                            }
                        />
                    </div>
                </div>
                <div className='row attendance-list-filter-container attendance-list-filter-mobile'>
                    <div className='col attendance-list-filter-inner-div'>
                    </div>
                </div>
                
                <div className='attendance-list-main-container'>
                    {
                        isAttendanceList
                            ?
                            <AdvancedTable columns={tableColumnsList} data={[...dataList]} isLoading={isLoading} handleLoadMore={handleLoadMore} onClickDetails={onClickAttendance} rowCount={dataMeta.count} />
                            :
                            <AdvancedTable columns={tableColumnsSummary} data={[...dataSummaryList]} isLoading={isLoading} handleLoadMore={handleLoadMore} onClickDetails={onClickAttendance} rowCount={dataSummaryMeta.count} />
                    }
                </div>
            </div>
        </div>
    );
}


export default AttendanceList;
